<template>
  <div class="purchase-order-deeplink-component">
    Redirecting...
  </div>
</template>

<script>
export default {
  created() {
    const purchaseOrderId = this.$route.params.purchaseOrderId;
    let route = {
      name: 'home',
    };

    if (purchaseOrderId) {
      route.query = {
        po: purchaseOrderId,
      };
    }

    this.$router.push(route);
  },
};
</script>

<style lang="scss" scoped>
.purchase-order-deeplink-component {
  display: none;
}
</style>